<app-header></app-header>

<ion-content [fullscreen]="true" class="settings-content">
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col size="12">
        <!-- Profile Card -->
        <ion-card class="profile-card">
          <ion-card-header>
            <div class="profile-header">
              <div class="profile-info">
                <ion-card-title>{{ user()?.displayName || 'User' }}</ion-card-title>
                <ion-card-subtitle class="profile-email">{{ user()?.email || '' }}</ion-card-subtitle>
              </div>
            </div>
          </ion-card-header>
        </ion-card>

        <!-- Section: Language -->
        <div class="section-title">{{ 'PROFILE.LANGUAGE' | translate }}</div>
        <ion-card class="settings-section-card compact-card">
          <ion-card-content>
            <ion-segment [(ngModel)]="selectedLanguage" (ionChange)="useLanguage(selectedLanguage)">
              <ion-segment-button value="en">
                <span class="flag-emoji">🇬🇧</span>
                <span>English</span>
              </ion-segment-button>
              <ion-segment-button value="ge">
                <span class="flag-emoji">🇬🇪</span>
                <span>ქართული</span>
              </ion-segment-button>
            </ion-segment>
          </ion-card-content>
        </ion-card>

        <!-- Section: Phone Number -->
        <div class="section-title">{{ 'PROFILE.MOBILE.PHONE' | translate }}</div>
        <ion-card class="settings-section-card compact-card">
          <ion-card-content>
            <!-- Success State -->
            @if(showSuccessState()) {
            <div class="success-state">
              <div class="success-icon">
                <ion-icon name="checkmark-circle" color="success"></ion-icon>
              </div>
              <h3 class="success-title">{{ 'PROFILE.PHONE_SUCCESSFULLY_CHANGED' | translate }}</h3>
              <ion-button color="primary" shape="round" size="large" class="continue-button" (click)="continueToHome()">
                <ion-icon name="print-outline" slot="start"></ion-icon>
                {{ 'PROFILE.CONTINUE_TO_HOME' | translate }}
              </ion-button>
            </div>
            }
            <!-- Phone Number Form -->
            <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
              <ion-item lines="full" class="input-item">
                <ion-input
                  [label]="'PROFILE.MOBILE.PHONE' | translate"
                  #mobileInput
                  placeholder="995-5XX-XXX-XXX"
                  formControlName="phone"
                  labelPlacement="floating"
                  maxlength="15"
                  type="tel"
                  (ionInput)="formatPhoneNumber($event)"></ion-input>
                <ion-note slot="helper">995-5XX-XXX-XXX</ion-note>
              </ion-item>
              <ion-text color="danger" *ngIf="phone?.hasError('pattern') && phone?.touched">
                {{ 'PROFILE.MOBILE.PHONE.PATTERN.REQUIRED' | translate }}
              </ion-text>
              <ion-text color="danger" *ngIf="phone?.hasError('required') && phone?.touched">
                {{ 'PROFILE.MOBILE.PHONE.REQUIRED' | translate }}
              </ion-text>
              <div class="button-row">
                <ion-button
                  color="primary"
                  shape="round"
                  type="submit"
                  [disabled]="isButtonDisabled() || profileForm.invalid">
                  {{ 'PROFILE.MOBILE.PHONE.SAVE' | translate }}
                </ion-button>
              </div>
            </form>
          </ion-card-content>
        </ion-card>

        <div class="section-title">{{ 'PROFILE.LOGOUT' | translate }}</div>
        <ion-card class="settings-section-card compact-card">
          <ion-card-content>
            <div class="button-row" style="margin-top: 16px">
              <ion-button color="medium" shape="round" (click)="confirmLogout()">
                {{ 'PROFILE.LOGOUT' | translate }}
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>

        <!-- Section: Privacy & Cookie Settings -->
        <div class="section-title">{{ 'SETTINGS.CONSENT.TITLE' | translate }}</div>
        <ion-card class="settings-section-card compact-card">
          <ion-card-content>
            <p class="consent-description">{{ 'SETTINGS.CONSENT.DESCRIPTION' | translate }}</p>

            @if(userConsent()) {
            <div class="consent-status">
              <div class="status-item">
                <ion-icon
                  [name]="userConsent()?.settings?.analytics ? 'checkmark-circle' : 'close-circle'"
                  [color]="userConsent()?.settings?.analytics ? 'success' : 'danger'">
                </ion-icon>
                <span
                  >{{ userConsent()?.settings?.analytics ? ('SETTINGS.CONSENT.ANALYTICS_ENABLED' | translate) :
                  ('SETTINGS.CONSENT.ANALYTICS_DISABLED' | translate) }}</span
                >
              </div>
              @if(userConsent()?.consentDate) {
              <div class="consent-date">
                <small
                  >{{ 'SETTINGS.CONSENT.LAST_UPDATED' | translate }}: {{ userConsent()?.consentDate | date:'medium'
                  }}</small
                >
              </div>
              }
            </div>
            }

            <div class="button-row" style="margin-top: 16px">
              <ion-button color="primary" shape="round" (click)="manageConsent()">
                <ion-icon name="settings-outline" slot="start"></ion-icon>
                {{ 'SETTINGS.CONSENT.MANAGE' | translate }}
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>

        <!-- Section: Notifications -->
        @if(authService.isUserProvider()) {
        <div class="section-title">{{ 'NOTIFICATIONS.TITLE' | translate }}</div>
        <ion-card class="settings-section-card compact-card">
          <ion-card-content>
            <div class="button-row" style="margin-top: 16px">
              <ion-button color="secondary" shape="round" (click)="turnOnNotifications()">
                <ion-icon name="notifications-outline" slot="start"></ion-icon>
                {{ 'NOTIFICATIONS.TURN_ON' | translate }}
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>
        }

        <!-- Section: Delete Account -->
        <div class="section-title" style="color: #c00">{{ 'SETTINGS.DELETE_ACCOUNT' | translate }}</div>
        <ion-card class="settings-section-card compact-card">
          <ion-card-content>
            <ion-text color="danger"> {{ 'SETTINGS.DELETE_ACCOUNT.DESCRIPTION' | translate }} </ion-text>
            <div class="button-row" style="margin-top: 16px">
              <ion-button color="danger" shape="round" (click)="confirmDeleteAccount()">
                {{ 'SETTINGS.DELETE_ACCOUNT' | translate }}
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>

        <!-- Loading & Error States (placeholders) -->
        <ion-spinner *ngIf="loading"></ion-spinner>
        <ion-text color="danger" *ngIf="error">{{ error }}</ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
